<div>    
    <app-bi-dashboard-lista
        [filtros]="filtros"
        (definirFiltro)="definirFiltro()"
        (exibir)="selecionar($event)">    
    </app-bi-dashboard-lista>
</div>
